export default __webpack_public_path__ + "static/media/blog1.023b89cb.jpeg";